import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import type { AppDispatch } from "../../redux/store";

import {
  HeaderSection,
  MainContainer,
  Type,
  DeleteButton,
  Container,
  BackButton,
} from "./ProjectPreview.styles";

import BackIcon from "../../assets/images/Common/back-icon.png";
import DeleteIcon from "../../assets/images/Common/deleteIcon.png";
import { useReadOnlyUser } from "../../hooks/useReadOnlyUser";
import { projectByIdSelector, deleteProject } from "../../redux";
import { getProjectById } from "../../redux/actions/get/getProjectById";

import Tabs from "../Tabs/Tabs";
import { PageContainer } from "../Projects/Projects.styles";
import DeleteProject from "../DeleteProject/DeleteProject";
import ProjectInformation from "../ProjectInformation/ProjectInformation";
import BudgetList from "../BudgetList/BudgetList";
import InspectionData from "../InspectionData/Inspection";
import { toast } from "react-toastify";
import Report from "../Reports/Report";

const ProjectPreview: React.FC = () => {
  const [isDelete, setDelete] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const { currentProject } = useSelector(projectByIdSelector);
  const { pName } = currentProject || {};
  const [isLoading, setIsLoading] = useState(false);
  const isReadonlyUser = useReadOnlyUser();

  const { companyId, projectId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    companyId &&
      projectId &&
      dispatch(getProjectById({ companyId, projectId }));
  }, [dispatch, companyId, projectId]);

  const onDeleteHandler = () => {
    setIsLoading(true);
    dispatch(
      deleteProject({ companyId, projectId }, (res) => {
        setDelete(false);
        setIsLoading(false);
        if (res?.success) {
          notifySuccess(res?.message, () => {
            navigate(-1);
          });
        } else {
          notifyError(res?.message || "Not able to delete project");
        }
      })
    );
  };

  const notifyError = (message) =>
    toast.error(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const notifySuccess = (message, onclose) => {
    toast.success(message, {
      position: "top-right",
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      onClose: onclose,
    });
  };
  const navigateToProjects = () => {
    navigate(`/home/${companyId}`);
  };

  return (
    <PageContainer>
      <MainContainer>
        {isDelete && (
          <DeleteProject
            setShow={() => setDelete(false)}
            projectId={projectId}
            companyId={companyId}
            onDelete={onDeleteHandler}
            isLoading={isLoading}
          />
        )}
        <HeaderSection>
          <BackButton onClick={navigateToProjects}>
            <img src={BackIcon} alt="level" />
          </BackButton>
          {projectId && <Type>{pName}</Type>}
          <DeleteButton
            onClick={() => {
              setDelete(true);
            }}
            disabled={isReadonlyUser}
          >
            <img src={DeleteIcon} alt="menuButton" title="Delete Project" />
          </DeleteButton>
        </HeaderSection>
        <Container>
          <Tabs
            tabData={[
              {
                label: "Project Information",
                value: "1",
                content: (
                  <ProjectInformation
                    projectId={projectId}
                    companyId={companyId ?? ""}
                  />
                ),
              },
              {
                label: "Budgets",
                value: "2",
                content: (
                  <BudgetList
                    pId={projectId}
                    cId={companyId ?? ""}
                    pName={pName}
                  />
                ),
              },
              {
                label: "Inspection Data",
                value: "4",
                content: (
                  <InspectionData
                    pId={projectId ?? ""}
                    cId={companyId ?? ""}
                    pName={pName}
                  />
                ),
              },
              {
                label: "Reports",
                value: "5",
                content: (
                  <Report projectId={projectId} companyId={companyId ?? ""} />
                ),
              },
            ]}
          />
        </Container>
      </MainContainer>
    </PageContainer>
  );
};

export default ProjectPreview;
